import { useContext, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import Button from "../components/Button";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";

const OTPProtectedRoute = ({ children }) => {
  const { session, supabase } = useContext(AuthContext);
  const [email, setEmail] = useState(null);
  const [step, setStep] = useState("signup");
  const [isLoading, setIsLoading] = useState(false);
  const { rectangleId } = useParams();

  const requestOTP = async (email) => {
    setIsLoading(true);
    const { data, error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: `http://localhost:3000/share/${rectangleId}`,
      },
    });
    setIsLoading(false);
    setStep("confirm_email");
  };

  // Redirect to login if not signed in
  if (!session) {
    return (
      <div className="pt-20">
        {rectangleId}
        <div
          className=" mx-auto border gap-8 shadow-xl shadow-gray-100 shadow-opacity-20 rounded-2xl bg-white "
          style={{ maxWidth: 600 }}
        >
          <div className="bg-gray-100 bg-opacity-40  px-8 py-8">
            <img src={"/logo.png"} className="mt-2" style={{ width: 180 }} />
          </div>

          {step == "signup" && (
            <section className="login space-y-2 px-8 pt-2 pb-8">
              <h1 className="font-semibold text-sm mt-6 mb-1">
                Sign in with a magic link to view this shipment
              </h1>

              <input
                type="email"
                disabled={isLoading}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="border rounded-md text-sm w-full border-gray-200 outline-0"
              />
              <Button
                onClick={() => requestOTP(email)}
                label={"Request magic link"}
              />
            </section>
          )}

          {step == "confirm_email" && (
            <section className="login mt-8  px-8 pb-8">
              <p className="text-sm text-gray-700 font-medium">
                We've sent you an email with a confirmation link <br />
                <span className="text-sm mb-4 text-gray-400">{email}</span>
              </p>
              <p
                onClick={() => setStep("signup")}
                className="mt-8 flex cursor-pointer items-center space-x-2"
              >
                <ArrowLeftIcon className="w-4" />
                <p className="font-semibold text-xs text-gray-600">Go back</p>
              </p>
            </section>
          )}
        </div>
      </div>
    );
  }

  // If signed in and onboarding completed (or doesn't require completion)
  return children;
};

export default OTPProtectedRoute;
